import { createContext } from 'react'

export interface TileModalToppingContextData {
  tileToppings: ItemTopping[]
  tile: Tile
  toppingName: string
  selectedTopping: ItemTopping | undefined
}

export const TileModalToppingContext = createContext<TileModalToppingContextData>({} as TileModalToppingContextData)
